export default __webpack_public_path__ + "static/media/Whats-in-the-Name.fe5b7da7.jpg";